<template>
  <v-container class="pa-0">
    <v-row align="center" justify="center" :style="contentsHeight">
      <v-col cols="6" class="pa-1">
        <app-alert v-if="error" @dismissed="onDismissed" :text="error.message"></app-alert>
        <v-toolbar dark flat color="primary" class="rounded-t-xl">
          <v-spacer></v-spacer>
          <v-toolbar-title>ログイン</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card class="pa-1 rounded-b-xl" elevation="0" outlined>
          <v-row align="center" class="ma-0">
            <v-col cols="12" class="py-0" align="end">
              <small>*</small><small class="error--text font-weight-bold caption">必須</small>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="ma-0">
            <v-col cols="8" class="py-0" align="center">
              <v-text-field
                ref="id"
                prepend-icon="mdi-security"
                name="ID"
                label="* 利用者登録ID"
                placeholder=""
                v-model="id"
                type="text"
                class="title"
                clearable
                :rules="[rules.required, rules.entry]"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" align="center">
              <span>Google アカウントで登録した方はこちらから</span>
            </v-col>
            <v-col cols="12" align="center">
              <v-btn rounded color="primary" depressed @click="googleLogIn" :disabled="!pp">Login</v-btn>
            </v-col>
            <v-col cols="12" align="center">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" align="center">
              <span>メールアドレスで登録した方はこちらから</span>
            </v-col>
            <v-col cols="12" align="center" class="px-4">
              <v-form v-model="rules.valid">
                <v-form v-model="rules.emailValid">
                  <v-text-field
                    id="email"
                    ref="email"
                    autocomplete="off"
                    prepend-icon="mail"
                    name="login"
                    label="*メールアドレス"
                    v-model="email"
                    type="email"
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>
                </v-form>
                <v-text-field
                  id="password"
                  ref="password"
                  autocomplete="off"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  prepend-icon="lock"
                  name="password"
                  label="*パスワード"
                  v-model="password"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  :rules="[rules.required, rules.min]"
                >
                </v-text-field>
              </v-form>
            </v-col>
            <v-col cols="12" class="py-0" align="end">
              <v-btn outlined rounded :color="rules.emailValid ? 'error' : 'grey'" x-small depressed @click.stop="rules.emailValid ? resetDialog = true : true" :disabled="!(rules.emailValid && pp)">パスワードを忘れました</v-btn>
            </v-col>
            <v-col cols="12" class="pa-0" align="center">
              <v-btn rounded color="primary" depressed @click="onSignin" :disabled="!(rules.valid && pp)">Login</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <div class="text-center">
      <v-dialog v-model="resetDialog" persistent max-width="360">
        <v-card>
          <v-card-title class="title primary white--text">パスワードリセット</v-card-title>
          <v-card-text class="py-2 px-4">{{ 'パスワードを初期化する為の URLをこちらのメールアドレスを送信します。: ' + email }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded depressed @click="resetDialog = false">取消</v-btn>
            <v-btn color="primary" rounded depressed @click.native="onResetPassword()">実行</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      resetDialog: false,
      show1: false,
      email: '',
      password: '',
      id: null,
      pp: true,
      rules: {
        valid: false,
        emailValid: false,
        required: value => !!value || '必須',
        password: value => value === this.password || 'パスワードが違います',
        min: value => (!!value && value.length >= 6) || '最低でも 6文字が必要です',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '無効なメールアドレスです'
        },
        entry: value => {
          const pattern = /^[a-zA-Z0-9]{10}$/
          return pattern.test(value) || '無効な ID です'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      error: 'shared/error',
      loading: 'shared/loading',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 40) + 'px;'
    }
  },
  created () {
    this.email = localStorage.enmail ? localStorage.enmail : null
    this.id = localStorage.id ? localStorage.id : null
    // this.pp = localStorage.check ? localStorage.check : false
  },
  methods: {
    onSignin () {
      var vm = this
      if (this.$refs.email.validate(true) && this.$refs.password.validate(true) && this.$refs.id.validate(true)) {
        this.$store.dispatch('auth/checkID', { id: this.id }).then(function (resp) {
          if (resp) {
            localStorage.email = vm.email
            localStorage.id = vm.id
            localStorage.check = vm.pp
            localStorage.school = resp.key
            vm.$store.dispatch('auth/signUserIn', { email: vm.email, password: vm.password })
          }
        })
      }
    },
    googleLogIn () {
      var vm = this
      if (this.$refs.id.validate(true)) {
        this.$store.dispatch('auth/checkID', { id: this.id }).then(function (resp) {
          if (resp) {
            localStorage.id = vm.id
            localStorage.school = resp.key
            vm.$store.dispatch('auth/googleLogIn')
          }
        })
      }
    },
    onResetPassword () {
      var vm = this
      this.resetDialog = false
      var auth = firebase.auth()
      auth.languageCode = 'ja'
      auth.sendPasswordResetEmail(this.email).then(function () {
        vm.$nextTick(function () {
          vm.goto(this, '/')
        })
      }).catch(function (error) {
        if (error) {
          // console.log(error)
        }
        vm.$store.dispatch('shared/setError', error)
      })
    },
    onDismissed () {
      this.$store.dispatch('shared/setError', null)
    }
  }
}
</script>

<style scoped>
</style>
